/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class VulnerabilityTrendWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("VulnerabilityTrendWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return VulnerabilityTrendWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<VulnerabilityTrendWidgetConfiguration>): VulnerabilityTrendWidgetConfiguration {
        let obj = Object.assign(new VulnerabilityTrendWidgetConfiguration(), model);
        VulnerabilityTrendWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<VulnerabilityTrendWidgetConfiguration>): VulnerabilityTrendWidgetConfiguration {
        if (!model) return null;
        return VulnerabilityTrendWidgetConfiguration.newInstance(<VulnerabilityTrendWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: VulnerabilityTrendWidgetConfiguration) {
        if (!obj) return;

        models.VulnerabilityTrendWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: VulnerabilityTrendWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, VulnerabilityTrendWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
